import React, { useEffect, useRef, useState } from 'react';
import {
  BottomStickyStrip,
  ConsultStrip,
  StripText,
} from '../ConsultNudge/styled';
import Modal from 'react-modal';
import { SharePopupStyle } from '../../../Utils/redirections';
import { NextImageStyleCover } from '../../BabyNameFinder/styled';
import Image from 'next/image';
import { images } from '../../../Constants/ImageUrls';
import { ModalCrossbtn } from '../../Product/TrustStrip/styled';
import { useRouter } from 'next/router';
import { getSearchParams } from '../../Parenting/common';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { fireOpenPopupEvent } from '../../../Utils/babynames';
import { createRippleEffectRelative } from '../../../Utils/helper';
import {
  assessmentText,
  clickedCtaEvent,
  discardPopupEvent,
  servedStrip,
} from './instrumentation';

function AssessmentStrip(props) {
  const articleId = props.articleId;
  const router = useRouter();
  const BottomStylePopup = SharePopupStyle('', '', '0', '');
  const [installPopup, setInstallPopup] = useState(false);
  const [showBottomStrip, setShowBottomStrip] = useState(false);
  const throttleTimeout = useRef();
  const [firstDiscard, setFirstDiscard] = useState(false);
  const [clickEffect, setClickEffect] = useState('');
  const handleClose = () => {
    setClickEffect('lowOpacity');
    setTimeout(() => {
      setClickEffect('');
      discardPopupEvent(assessmentText);
      setInstallPopup(false);
      setFirstDiscard(true);
    }, 500);
  };
  const oldScrollValue = useRef(0);
  const clickHandler = (type, e) => {
    if (e) {
      createRippleEffectRelative(e, document.getElementById('popupBtn'));
    }

    setClickEffect('lowOpacity');
    setTimeout(() => {
      setClickEffect('');
      clickedCtaEvent(assessmentText, '/form/52', type);
      router.push(
        `/form/52` + getSearchParams({ sourceArticle: articleId }),
        '',
        {
          locale: getRouterLocale(router),
        },
      );
    }, [300]);
  };

  function scrollUpOrDown() {
    if (!throttleTimeout.current) {
      setTimeout(() => {
        let newValue = window.pageYOffset;

        if (newValue > 65) setShowBottomStrip(true);
        else setShowBottomStrip(false);
        throttleTimeout.current = false;
      }, 100);
    }
    throttleTimeout.current = true;
  }

  function handleScroll() {
    const scrollPercentage =
      (window.scrollY /
        (document.documentElement.scrollHeight - window.innerHeight)) *
      100;
    if (scrollPercentage >= 30) {
      setInstallPopup(true);
      setShowBottomStrip(true);

      window.removeEventListener('scroll', handleScroll);
    }
  }

  useEffect(() => {
    servedStrip('served_strip', 'Top Strip');
    if (firstDiscard) {
      setFirstDiscard(false);
    }
    window.addEventListener('scroll', scrollUpOrDown);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', scrollUpOrDown);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [articleId]);
  useEffect(() => {
    if (installPopup) fireOpenPopupEvent(assessmentText);
  }, [installPopup]);
  useEffect(() => {
    if (showBottomStrip) servedStrip('served_strip', 'Bottom Strip');
  }, [showBottomStrip]);
  return (
    <>
      <ConsultStrip
        className="assessmentStrip"
        color="#58bcc6"
        onClick={() => clickHandler('Top Strip')}
      >
        <p className="leftText">Trying to get pregnant?</p>
        <StripText className={clickEffect}>
          {assessmentText}{' '}
          <img src={images.arrowForwardWhite} alt="" loading="lazy" />
        </StripText>
      </ConsultStrip>
      {showBottomStrip && firstDiscard ? (
        <BottomStickyStrip>
          <ConsultStrip
            color="#58bcc6"
            onClick={() => clickHandler('Bottom Strip')}
            className="shimmer"
          >
            <span></span>
            <StripText className={`${clickEffect} botStrip`}>
              {assessmentText}{' '}
              <img src={images.arrowForwardWhite} alt="" loading="lazy" />
            </StripText>
          </ConsultStrip>
        </BottomStickyStrip>
      ) : null}
      <Modal
        isOpen={installPopup}
        onRequestClose={handleClose}
        style={BottomStylePopup}
        preventScroll={true}
        className={{
          base: 'shareModal',
          afterOpen: 'shareModalOpen',
          beforeClose: 'shareModalClose',
        }}
        bodyOpenClassName="noScroll"
        htmlOpenClassName="noScroll"
      >
        <NextImageStyleCover>
          <Image
            src={
              'https://images.myloapp.in/NestJsUploads/1707114357223-Fertility-Assessment_2111.gif'
            }
            onClick={() => clickHandler('popup_banner')}
            alt={'Install App'}
            quality={90}
            fill
            sizes="100vw"
          />
        </NextImageStyleCover>
        <ConsultStrip
          color="#ef4e5e"
          onClick={(e) => clickHandler('popup_button', e)}
          id="popupBtn"
          className="popupCta"
        >
          <StripText className={`botStrip2`}>
            {assessmentText}{' '}
            <img src={images.arrowForwardWhite} alt="" loading="lazy" />
          </StripText>
        </ConsultStrip>
        <ModalCrossbtn
          onClick={handleClose}
          src={images.CrossWhite}
          alt="share popup close"
          className={clickEffect}
        ></ModalCrossbtn>
      </Modal>
    </>
  );
}

export default AssessmentStrip;
